var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "PurchaseReturnWaybill" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "DocumentDate",
                                error: _vm.$v.form.DocumentDate,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDatePicker", {
                                attrs: {
                                  disabled: _vm.insertReadonly.DocumentDate
                                },
                                model: {
                                  value: _vm.documentDate,
                                  callback: function($$v) {
                                    _vm.documentDate = $$v
                                  },
                                  expression: "documentDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "DocumentTime",
                                error: _vm.$v.form.DocumentTime,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextTimePicker", {
                                attrs: {
                                  disabled: _vm.insertReadonly.DocumentTime
                                },
                                model: {
                                  value: _vm.form.DocumentTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "DocumentTime", $$v)
                                  },
                                  expression: "form.DocumentTime"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "CustomerId",
                                error: _vm.$v.form.CustomerId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  url:
                                    "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                                  searchable: true,
                                  "custom-option": true,
                                  disabled: _vm.insertReadonly.CustomerId,
                                  label: "Description1",
                                  "or-condition-fields":
                                    "Code,Description1,CommercialTitle",
                                  "is-customer": true
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectedSearchType(
                                      "CustomerId",
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.selectedCustomer,
                                  callback: function($$v) {
                                    _vm.selectedCustomer = $$v
                                  },
                                  expression: "selectedCustomer"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "PriceListId",
                                error: _vm.$v.form.PriceListId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.priceList,
                                  label: "Description1",
                                  disabled: _vm.insertReadonly.PriceListId
                                },
                                model: {
                                  value: _vm.selectedPrice,
                                  callback: function($$v) {
                                    _vm.selectedPrice = $$v
                                  },
                                  expression: "selectedPrice"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("b-card", { staticClass: "summary-card" }, [
                        _c("div", { staticClass: "summary-area" }, [
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.netTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.NetTotal))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.vatTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.TotalVat))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "summary-title" }, [
                            _vm._v(_vm._s(_vm.$t("insert.order.grossTotal")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "summary-value text-muted" },
                            [_vm._v(": " + _vm._s(_vm.form.GrossTotal))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("hr", { staticClass: "summary-hr" })
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.order.enterWaybill"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceNumber",
                            error: _vm.$v.form.InvoiceNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.InvoiceNumber
                            },
                            model: {
                              value: _vm.form.InvoiceNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "InvoiceNumber", $$v)
                              },
                              expression: "form.InvoiceNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PrintedDispatchNumber",
                            error: _vm.$v.form.PrintedDispatchNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.PrintedDispatchNumber
                            },
                            model: {
                              value: _vm.form.PrintedDispatchNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PrintedDispatchNumber", $$v)
                              },
                              expression: "form.PrintedDispatchNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceKindId",
                            error: _vm.$v.form.InvoiceKindId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              disabled: _vm.insertReadonly.InvoiceKindId,
                              url: "VisionNextInvoice/api/InvoiceKind/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "InvoiceKindId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedInvoiceKind,
                              callback: function($$v) {
                                _vm.selectedInvoiceKind = $$v
                              },
                              expression: "selectedInvoiceKind"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DocumentNumber",
                            error: _vm.$v.form.DocumentNumber,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.DocumentNumber
                            },
                            model: {
                              value: _vm.form.DocumentNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentNumber", $$v)
                              },
                              expression: "form.DocumentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Description1",
                            error: _vm.$v.form.Description1,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Description1
                            },
                            model: {
                              value: _vm.form.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Description1", $$v)
                              },
                              expression: "form.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RepresentativeId",
                            error: _vm.$v.form.RepresentativeId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              orConditionFields:
                                "Code,Description1,Name,Surname",
                              url: "VisionNextEmployee/api/Employee/Search",
                              disabled: _vm.insertReadonly.RepresentativeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RepresentativeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedRepresentative,
                              callback: function($$v) {
                                _vm.selectedRepresentative = $$v
                              },
                              expression: "selectedRepresentative"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DeliveryRepresentativeId",
                            error: _vm.$v.form.DeliveryRepresentativeId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              orConditionFields:
                                "Code,Description1,Name,Surname",
                              url: "VisionNextEmployee/api/Employee/Search",
                              disabled:
                                _vm.insertReadonly.DeliveryRepresentativeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DeliveryRepresentativeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedDeliveryRepresentative,
                              callback: function($$v) {
                                _vm.selectedDeliveryRepresentative = $$v
                              },
                              expression: "selectedDeliveryRepresentative"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CurrencyId,
                              source: _vm.currencies
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedCurrency,
                              callback: function($$v) {
                                _vm.selectedCurrency = $$v
                              },
                              expression: "selectedCurrency"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "WarehouseId",
                            error: _vm.$v.form.WarehouseId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              disabled: true,
                              url: "VisionNextWarehouse/api/Warehouse/Search",
                              "dynamic-and-condition": { IsVehicle: 1 }
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "WarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedWarehouse,
                              callback: function($$v) {
                                _vm.selectedWarehouse = $$v
                              },
                              expression: "selectedWarehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "VehicleId",
                            error: _vm.$v.form.VehicleId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              url:
                                "VisionNextVehicle/api/Vehicle/AutoCompleteSearch",
                              "dynamic-and-condition": { StatusIds: [1] },
                              "page-count": 1000,
                              disabled:
                                _vm.form.InvoiceLogisticCompanies &&
                                _vm.form.InvoiceLogisticCompanies.length > 0
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "VehicleId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedVehicle,
                              callback: function($$v) {
                                _vm.selectedVehicle = $$v
                              },
                              expression: "selectedVehicle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteId",
                            error: _vm.$v.form.RouteId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RouteId,
                              url:
                                "VisionNextRoute/api/Route/AutoCompleteSearch",
                              "order-by-columns": [
                                { Column: "Description1", OrderByType: 0 }
                              ],
                              "dynamic-and-condition": { StatusIds: [1] },
                              "page-count": 500
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType("RouteId", $event)
                              }
                            },
                            model: {
                              value: _vm.selectedRoute,
                              callback: function($$v) {
                                _vm.selectedRoute = $$v
                              },
                              expression: "selectedRoute"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "EDocumentStatusId",
                            error: _vm.$v.form.EDocumentStatusId,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              source: _vm.eDocumentStatus,
                              disabled: _vm.insertReadonly.EDocumentStatusId
                            },
                            model: {
                              value: _vm.selectedEDocumentStatus,
                              callback: function($$v) {
                                _vm.selectedEDocumentStatus = $$v
                              },
                              expression: "selectedEDocumentStatus"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ActualDeliveryDate",
                            error: _vm.$v.form.ActualDeliveryDate,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.ActualDeliveryDate
                            },
                            model: {
                              value: _vm.form.ActualDeliveryDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ActualDeliveryDate", $$v)
                              },
                              expression: "form.ActualDeliveryDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ActualDeliveryTime",
                            error: _vm.$v.form.ActualDeliveryTime,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextTimePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.ActualDeliveryTime
                            },
                            model: {
                              value: _vm.form.ActualDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ActualDeliveryTime", $$v)
                              },
                              expression: "form.ActualDeliveryTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.order.enterProducts") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c("NextExportDetail", {
                        attrs: {
                          url:
                            "VisionNextInvoice/api/PurchaseReturnWaybill/ExcelExportItems",
                          "record-id": _vm.form.RecordId,
                          "record-key": "invoiceId",
                          "file-name": _vm.$t("insert.order.enterProducts")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.product")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.productCode"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.quantity"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.price")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.vatRate")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.netTotal"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.vatTotal"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.grossTotal"))
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(
                              _vm.form.InvoiceLines
                                ? _vm.form.InvoiceLines.filter(function(x) {
                                    return x.RecordState != 4
                                  })
                                : [],
                              function(o, i) {
                                return _c(
                                  "b-tr",
                                  { key: i },
                                  [
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(
                                          o.Item ? o.Item.Label : o.Description1
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(
                                          o.Item ? o.Item.Code : o.ItemCode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.Quantity))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.Price))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.VatRate))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.NetTotal))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.TotalVat))]),
                                    _vm._v(" "),
                                    _c("b-td", [_vm._v(_vm._s(o.GrossTotal))])
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.order.logisticCompanies"),
                    disabled: _vm.form.VehicleId > 0
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.order.companyName"),
                            error:
                              _vm.$v.selectedInvoiceLogisticCompany.companyName,
                            required: true,
                            md: "4",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value:
                                _vm.selectedInvoiceLogisticCompany.companyName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedInvoiceLogisticCompany,
                                  "companyName",
                                  $$v
                                )
                              },
                              expression:
                                "selectedInvoiceLogisticCompany.companyName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.order.taxNumber"),
                            error:
                              _vm.$v.selectedInvoiceLogisticCompany.taxNumber,
                            required: true,
                            md: "4",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              maxLength: 10,
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value:
                                _vm.selectedInvoiceLogisticCompany.taxNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedInvoiceLogisticCompany,
                                  "taxNumber",
                                  $$v
                                )
                              },
                              expression:
                                "selectedInvoiceLogisticCompany.taxNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("NextAddress", {
                    attrs: {
                      required: true,
                      "city-error":
                        _vm.$v.selectedInvoiceLogisticCompany.cityId.$error,
                      "district-error":
                        _vm.$v.selectedInvoiceLogisticCompany.districtId.$error,
                      "hide-address": true,
                      md: "4",
                      lg: "3"
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "12", md: "8", lg: "6" }
                    },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("AddDetailButton", {
                            nativeOn: {
                              click: function($event) {
                                return _vm.addInvoiceLogisticCompany($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.companyName"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.taxNumber"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("insert.order.city")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("insert.order.district"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(_vm.form.InvoiceLogisticCompanies, function(
                              l,
                              i
                            ) {
                              return _c(
                                "b-tr",
                                { key: i },
                                [
                                  _c("b-td", [_vm._v(_vm._s(l.CompanyName))]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(l.TaxNumber))]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(
                                      _vm._s(l.City ? l.City.Label : l.CityName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(
                                      _vm._s(
                                        l.District
                                          ? l.District.Label
                                          : l.DistrictName
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", { staticClass: "text-center" }, [
                                    _c("i", {
                                      staticClass:
                                        "far fa-trash-alt text-danger",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeInvoiceLogisticCompany(
                                            l
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-680a1697", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680a1697","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseReturnWaybill/update.vue
// module id = null
// module chunks = 